<template>
  <div class="bg-card text-left">
    <div class="d-flex justify-content-between">
      <h1>{{ $t('pages.admin.headhunters.title', 'Manage headhunters') }}</h1>
      <b-button
        v-if="$can('users_manage')"
        variant="success"
        size="sm"
        class="my-auto"
        @click="$router.push({ name: 'admin-add-hr' })"
      >
        {{ $t('generic.add-new', 'Add new') }}
      </b-button>
    </div>
    <Users :is-hr="true" />
  </div>
</template>

<script>
import Users from "./Users";
export default {
  components: {
    Users
  }
}
</script>
